import { BACKGROUND_TYPE } from '@lighthouse/core'
import { Group4ByecodeUi, ListItem4ByecodeUi } from '@lighthouse/shared'
import { Controller, useFormContext } from 'react-hook-form'

import { InheritLabel } from '@/components/InheritLabel'
import { FillColor } from '@/components/StyleSetting/components/FillColor'
import { useSetExtendsKeys } from '@/components/StyleSetting/hooks/useMouseEventDistance'

import type { ViewBreakPointSlice } from '../../View/formSlice'

export const ExpandReplies = () => {
    const { control } = useFormContext<ViewBreakPointSlice>()
    const { handleSetBreakKey } = useSetExtendsKeys()

    return (
        <Group4ByecodeUi label="展开回复控件">
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="文字颜色" name="breakPoint.viewStyles.replyStyle.color" />
                <Controller
                    control={control}
                    name="breakPoint.viewStyles.replyStyle.color"
                    render={({ field }) => (
                        <FillColor
                            enabledBackgroundTypes={[BACKGROUND_TYPE.color, BACKGROUND_TYPE.gradient]}
                            value={field.value}
                            onChange={val => {
                                field.onChange(val)
                                handleSetBreakKey('breakPoint.viewStyles.replyStyle.color')
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="图标颜色" name="breakPoint.viewStyles.replyStyle.iconColor" />
                <Controller
                    control={control}
                    name="breakPoint.viewStyles.replyStyle.iconColor"
                    render={({ field }) => (
                        <FillColor
                            enabledBackgroundTypes={[BACKGROUND_TYPE.color]}
                            value={field.value}
                            onChange={val => {
                                field.onChange(val)
                                handleSetBreakKey('breakPoint.viewStyles.replyStyle.iconColor')
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
        </Group4ByecodeUi>
    )
}
